const FALLBACK_TZ = 'Europe/Moscow';

const buildFormatter = (timeZone) =>
  new Intl.DateTimeFormat('ru-RU', {
    timeZone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

export const formatInTimezone = (isoString, timeZone = FALLBACK_TZ) => {
  if (!isoString) return '—';
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return '—';

  let formatter;
  try {
    formatter = buildFormatter(timeZone || FALLBACK_TZ);
  } catch (err) {
    console.warn('formatInTimezone: unsupported timezone, using fallback');
    formatter = buildFormatter(FALLBACK_TZ);
  }

  return formatter.format(date).replace(',', '');
};

/*
 * Дополнительные форматтеры для camera-bound timestamps (ТЗ №2 §10):
 * тот же fallback на Europe/Moscow при неподдерживаемой зоне.
 */

const safeFormatter = (locale, options, timeZone) => {
  try {
    return new Intl.DateTimeFormat(locale, { ...options, timeZone: timeZone || FALLBACK_TZ });
  } catch (err) {
    return new Intl.DateTimeFormat(locale, { ...options, timeZone: FALLBACK_TZ });
  }
};

const parseIso = (iso) => {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** «dd.MM HH:mm:ss» в зоне камеры (Gantt tooltip и т.п.). */
export const formatShortInTimezone = (iso, timeZone) => {
  const date = parseIso(iso);
  if (!date) return '—';
  return safeFormatter('ru-RU', {
    day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  }, timeZone).format(date).replace(',', '');
};

const WEEKDAY_INDEX = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

/** Часы/минуты/день недели (1=Пн) в зоне камеры — для сопоставления со сменами. */
export const getPartsInTimezone = (iso, timeZone) => {
  const date = parseIso(iso);
  if (!date) return null;
  const parts = safeFormatter('en-US', {
    hour: '2-digit', minute: '2-digit', weekday: 'short', hour12: false,
  }, timeZone).formatToParts(date);
  const pick = (type) => parts.find((part) => part.type === type)?.value;
  // Некоторые движки отдают «24» для полуночи при hour12:false.
  return {
    hour: Number(pick('hour')) % 24,
    minute: Number(pick('minute')),
    weekday: WEEKDAY_INDEX[pick('weekday')] ?? null,
  };
};

/** Подпись оси времени: «dd HH:mm» или «HH:mm» в заданной зоне. */
export const formatAxisTick = (iso, timeZone, withDate) => {
  const date = parseIso(iso);
  if (!date) return '';
  const options = withDate
    ? { day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }
    : { hour: '2-digit', minute: '2-digit', hour12: false };
  return safeFormatter('ru-RU', options, timeZone).format(date).replace(',', '');
};
